import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, AuthContext } from './contexts/AuthContext';
import { useContext } from 'react';
import InstallPrompt from './components/InstallPrompt';
import DesktopBlocker from './components/DesktopBlocker';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Home from './pages/Home';
import History from './pages/History';
import Bars from './pages/Bars';
import Resultado from './pages/Resultado';
import Payment from './pages/Payment';
import Profile from './pages/EditProfile';
import MusicListScreen from './pages/Lista';
import ForgotPassword from './pages/ForgotPassword';
import BirthdayScreen from './pages/BirthdayScreen';
import ManageRoom from './pages/ManageRoom';
import Shows from './pages/Shows';
import ShowRoom from './pages/ShowRoom';
import ArtistRequestAlerts from './components/ArtistRequestAlerts';
import PartyRoomPresence from './components/PartyRoomPresence';
import ShowSessionRestore from './components/ShowSessionRestore';

const PrivateRoute = ({ children }) => {
    const { userToken } = useContext(AuthContext);
    const location = useLocation();
    return userToken ? children : <Navigate to="/" state={{ from: location }} replace />;
};

function App() {
    return (
        <Router>
            <DesktopBlocker>
                <InstallPrompt />
                <AuthProvider>
                    <ArtistRequestAlerts />
                    <PartyRoomPresence />
                    <ShowSessionRestore><Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />

                        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
                        <Route path="/history" element={<PrivateRoute><History /></PrivateRoute>} />
                        <Route path="/bars" element={<PrivateRoute><Bars /></PrivateRoute>} />
                        <Route path="/resultado" element={<PrivateRoute><Resultado /></PrivateRoute>} />
                        <Route path="/payments" element={<PrivateRoute><Payment /></PrivateRoute>} />
                        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
                        <Route path="/aniversarios" element={<PrivateRoute><BirthdayScreen /></PrivateRoute>} />
                        <Route path="/list" element={<PrivateRoute><MusicListScreen /></PrivateRoute>} />
                        <Route path="/manage-room" element={<PrivateRoute><ManageRoom /></PrivateRoute>} />
                        <Route path="/shows" element={<PrivateRoute><Shows /></PrivateRoute>} />
                        <Route path="/shows/:id" element={<PrivateRoute><ShowRoom /></PrivateRoute>} />
                        <Route path="/manage-room/:roomId" element={<PrivateRoute><ManageRoom /></PrivateRoute>} />
                    </Routes></ShowSessionRestore>
                </AuthProvider>
            </DesktopBlocker>
        </Router>
    );
}

export default App;
